import React from 'react'
import { Label } from 'semantic-ui-react'

/**
 *
 * @param {object} props
 * @param {boolean} props.active
 * @param {object=} props.isAutomaticActive
 * @param {object=} props.style
 */
export function IntegrationStatusLabel({ active, isAutomaticActive, style }) {
  if (active) {
    return (
      <Label color="green" style={style}>
        {isAutomaticActive ? 'Always Active' : 'Active'}
      </Label>
    )
  } else {
    return <Label style={style}>Inactive</Label>
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntegrationStatusLabel/index.js